import PropTypes from 'prop-types';
import { Overlay } from '@eti/components';
import { BoundNew } from '@eti/types';
import ItineraryContent from './ItineraryContent';

const ItineraryOverlay = ({
  bounds,
  dataTestId,
  footer,
  id,
  isMultiStop,
  onClose,
  isOpen,
  shouldHideBaggageInfo,
  title,
  topNotification,
}) => {
  return (
    <Overlay.Drawer
      dataTestId="trip-itinerary-overlay"
      handleClose={onClose}
      id={id}
      isOpen={isOpen}
    >
      <Overlay.Header onClose={onClose} title={title} />
      <Overlay.Content data-testid="trip-itinerary-overlay-content">
        {topNotification}
        <ItineraryContent
          bounds={bounds}
          dataTestId={dataTestId}
          isMultiStop={isMultiStop}
          isOpen={isOpen}
          shouldHideBaggageInfo={shouldHideBaggageInfo}
        />
      </Overlay.Content>
      {footer && (
        <Overlay.Footer data-testid="trip-itinerary-overlay-footer">{footer}</Overlay.Footer>
      )}
    </Overlay.Drawer>
  );
};

ItineraryOverlay.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  dataTestId: PropTypes.string,
  footer: PropTypes.node,
  id: PropTypes.string,
  isMultiStop: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  shouldHideBaggageInfo: PropTypes.bool,
  title: PropTypes.string,
  topNotification: PropTypes.any,
};

export default ItineraryOverlay;
